import { types, successAction } from "@authzsvc/api-lib";

export default (state = { groups: [] }, action) => {
  switch (action.type) {
    case successAction(types.GET_ROLE_FOR_APPLICATION):
      return { ...state, ...action.payload.data };
    case successAction(types.GET_GROUPS_FOR_ROLE):
      return { ...state, groups: action.payload.data };
    case successAction(types.DELETE_GROUP_FROM_ROLE): {
      let new_groups = state.groups.filter(
        (group) => group.id !== action.payload.data.id,
      );
      return { ...state, groups: new_groups };
    }
    default:
      return state;
  }
};
